/// <reference types="@types/googlemaps" />
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import { ContactusComponent } from '../../../../hg-common/contactus/contactus.component';
import { MapsAPILoader } from '@agm/core';
// import { } from '@types/googlemaps';
import { ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
declare var google: any;

import { GooglePlaceDirective } from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-r-q8',
  templateUrl: './r-q8.component.html',
  styleUrls: ['./r-q8.component.css', '../residential-question.component.css'],
  entryComponents: [ContactusComponent],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ8Component implements OnInit {
  @Input() data: any;
  @Output() selectOn: EventEmitter<any> = new EventEmitter();
  @ViewChild('apt', { static: true }) inputEl: ElementRef;
  @ViewChild('apt_mob', { static: true }) inputEl_mob: ElementRef;
  @ViewChild('places', { static: true }) places: GooglePlaceDirective;
  @ViewChild('search', { static: true }) public searchElement: ElementRef;
  @ViewChild('template', { static: true }) template: ElementRef;
  @ViewChild('noservice', { static: true }) noService: ElementRef;
  @ViewChild('contact', { static: true }) contact: ElementRef;
  @ViewChild('thank', { static: true }) thank: ElementRef;

  apartment = '';
  address;
  formatedAddress;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  messagetype;
  user_bot = false;
  callUtilityAPI = false;

  componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
  };
  // For ngx-google-autocomplete
  lat;
  lng;
  options = {
    types: [],
    componentRestrictions: { country: 'US' },
  };
  isAddressSelected = false;
  geoMapAddress;
  deviceWidth;
  showMap = false;
  timer;
  time = 3000;
  typingTimer;
  showTyping = false;
  bounds: google.maps.LatLngBounds;
  markers: google.maps.Marker[];
  infoWindow: google.maps.InfoWindow;
  utilities;
  selectedUtility;
  modalRef: BsModalRef;
  zipcode;
  modalVisible = false;

  //help pop-up
  url = environment.api_url;
  userObj = {
    fullName: '',
    emailId: '',
    contactQues: '',
    type: 'contact',
  };
  // Save contact
  contactObj = {
    fullName: '',
    emailId: '',
    question: '',
  };
  display = 'none';
  esiidResponses = [];
  tempararyUtility;
  tempAddress;
  private loadUtilityNames = {
    TNMP: 'TNMP',
    AEPNORTH: 'AEPN',
    AEPCENTRAL: 'AEPC',
    CenterpointEnergy: 'CenterPoint',
    ONCOR: 'Oncor',

    CenterPoint: 'CenterPoint',
    Oncor: 'Oncor',
    AEPC: 'AEPC',
    AEPN: 'AEPN',
    LPL:'LPL'
  };
  private loadProvidersImageName = {
    TNMP: 'tnmp',
    AEPNORTH: 'AEP',
    AEPCENTRAL: 'AEP',
    CNP: 'CenterPoint_Energy',
    ONCOR: 'oncor',
    LPL:'LPL'
  };

  private loadActualUtilityNames = {
    TNMP: 'TNMP',
    AEPNORTH: 'AEPN',
    AEPCENTRAL: 'AEPC',
    CNP: 'CenterPoint',
    ONCOR: 'Oncor',
    LPL: 'LPL',
  };

  constructor(
    private residentialService: ResidentialService,
    private cd: ChangeDetectorRef,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private modalService: BsModalService,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  ngOnInit() {
    const autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      { types: ['geocode'] }


    );

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      this.selectOn.emit(
        this.getFormattedAddress(autocomplete.getPlace(), null)
      );
    });
    this.residentialService.currentId = this.data;
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ nextId: '0014' });
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        res_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.callUtilityAPI = true;
        this.address = obj.fieldValue.address;
        this.apartment = obj.fieldValue.apartment;
        this.formatedAddress = obj.fieldValue.formatedAddress;
        this.geoMapAddress = obj.fieldValue.geoMapAddress;
        this.selectedUtility =
          this.loadUtilityNames[this.trimUtilityName(obj.fieldValue.utility)];
        this.handleAddressChange(this.geoMapAddress);
        this.user_bot = true;
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    this.goNext()
 
    
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({ currentId: this.data });
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
      this.showTyping = false;
    }
  }

  public handleAddressChange(address) {
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({ currentId: this.data });
    }
    this.geoMapAddress = address;
    // Set the geometry details in service -> To load the map
    this.residentialService.address = address;
    if (typeof address.geometry.location.lng === 'number') {
      this.lng = address.geometry.location.lng;
      this.lat = address.geometry.location.lat;
    } else {
      this.lng = address.geometry.location.lng();
      this.lat = address.geometry.location.lat();
    }
    this.tempAddress = address;
    this.getFormattedAddress(address, this.apartment);
  }

  public getAprtment(event) {
    this.apartment = event.target.value;
    this.getFormattedAddress(this.tempAddress, this.apartment);
  }

  markerIconUrl() {
    return require('../../../../../assets/images/map-marker.png');
  }

  openModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  closeModal() {
    this.modalRef.hide();
    this.openModal(this.contact);
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

  closeModalWithOutContact() {
    this.residentialService.utilityName = this.selectedUtility;
    this.isAddressSelected = true;
    this.modalRef.hide();
    this.inputEl.nativeElement.focus();
    if (this.deviceWidth < 768) {
      this.inputEl_mob.nativeElement.focus();
      this.goNext();
    }
  }

  trimUtilityName(utilityName: string) {
    const utility = utilityName.replace(/\s/g, '');
    return utility.indexOf('(') > 0
      ? utility.substring(utility.indexOf('(') + 1, utility.length - 1)
      : utility;
  }

  onClose(isVisible: boolean) {
    this.modalVisible = isVisible;
  }

  getFormattedAddress(place, apartment) {
    this.formatedAddress = place.formatted_address;
    let addressValue = '';
    let zipcode;
    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        const val =
          place.address_components[i][this.componentForm[addressType]];
        addressValue = addressValue + addressType + ':' + val + ';';
      }
      if (place.address_components[i].types[0] === 'postal_code') {
        this.zipcode = place.address_components[i].long_name;
      }
    }
    this.esiidResponses = [];
    this.checkApiEsiValues(
      this.zipcode,
      this.formatedAddress,
      addressValue,
      apartment
    );
  }

  checkApiEsiValues(zipcode, formatedAddress, addressValue, apartment) {
    if (!this.callUtilityAPI) {
      this.residentialService.validateZipCode(zipcode).subscribe((res: any) => {
        if (res === `ZipCode: ${zipcode} did not return any TDSPs.`) {
          this.openModal(this.noService);
          this.isAddressSelected = false;
        } else {
          this.validateZipCodeForUtility(res);
          if (this.deviceWidth < 768) {
            this.next();
          }
        }
      });
      this.inputEl.nativeElement.focus();
      if (this.deviceWidth < 768) {
        this.inputEl_mob.nativeElement.focus();
      }
    } else {
      this.isAddressSelected = true;
    }
    this.address = addressValue;
    this.showMap = true;
  }

  validateZipCodeForUtility(response) {
    this.selectedUtility =
      this.loadActualUtilityNames[response[0].TdspName.replace(/-/g, '')];
    this.residentialService.utilityName = this.selectedUtility;
    this.isAddressSelected = true;
    if (response.length > 1) {
      this.utilities = response;
      this.openModal(this.template);
      const elem = document.getElementById(response[0].TdspName);
      elem.classList.add('active-select');
    }
  }

  selectUtility(utility) {
    this.tempararyUtility = utility;
    this.selectedUtility =
      this.loadActualUtilityNames[
        this.trimUtilityName(utility.replace(/-/g, ''))
      ];
    this.residentialService.utilityName = this.selectedUtility;
    const existingElements = document.getElementsByClassName('active-select');
    _.each(existingElements, function (item) {
      item.classList.remove('active-select');
    });
    const elem = document.getElementById(utility);
    elem.classList.add('active-select');
  }

  next() {
     if (this.selectedUtility) {
      this.user_bot = true;
      this.updateFormattedAddressResponse();
      this.inputEl.nativeElement.blur();
      if (this.deviceWidth < 768) {
        this.inputEl_mob.nativeElement.blur();
      }
      this.residentialService.messageService({ currentId: this.data });
      this.updateNotificationObject();
     }
  }

  updateNotificationObject() {
    this.residentialService.questionPercentage = JSON.parse(
      sessionStorage.getItem('percentage')
    );
    this.residentialService.user = JSON.parse(
      sessionStorage.getItem('userObj')
    );
    if (this.residentialService.user) {
      //let questionnarieObj = sessionStorage.getItem('userResponse');
 
      var msg = 'Complete your profile to see what energy plans Honest Gorilla is recommending for you.';
      // const addressObj = _.findWhere(this.userResponses, {
      //   fieldName: 'address',
      // });
      // if(addressObj != undefined && addressObj != null ) {
      //   var formatted_address = addressObj.fieldValue.formatedAddress; 
      //   formatted_address = formatted_address.replace(", USA","");
      //   msg = "Complete your profile regarding "+formatted_address+" to see what energy plans Honest Gorilla is recommending for you."
  
      // }
      var a = this.getFormattedAddressByState(this.formatedAddress);
      if(this.formatedAddress != undefined && this.formatedAddress != null && a != '') {

        var formatted_address = this.formatedAddress.replace(", USA","");
        var unit = (a['apartment'] != "" && a['apartment'] != undefined ?  a['apartment'] + ", " : "") ;
        var formatted_address__ = a['street_address'] + ", " + unit + a['city'] + ", " +  a['state'] + ", " + a['zipcode'];
        msg = "Complete your profile regarding "+formatted_address__+" to see what energy plans Honest Gorilla is recommending for you."
    
      }
   

      let notificationObj = {
        type: 'enrollment_not_completed',
        hg_orders_id: '',
        hg_accountId:
          this.residentialService.user &&
          this.residentialService.user._id === undefined
            ? ''
            : this.residentialService.user._id,
        esiid: '',
        showNotification: true,
        isRead: false,
        navigation_link: null,
        buttonName: 'Complete Profile',
        buttonUrl: '/residentialQues',
        order_no: '',
        userAddress: this.formatedAddress,
        questionnairePercent: this.residentialService.questionPercentage,
        percentage: this.residentialService.questionPercentage,
        title: "You're Almost Done",
        message:msg,
        createdBy: 0,
        lastUpdatedBy: 0,
        createdDate: this.residentialService.getServiceTypeDateObj(),
        lastUpdateDate: this.residentialService.getServiceTypeDateObj(),
        processCompleted: false,
        StraigthPlanUserRequest: null
      };
      this.residentialService.notificationObj = notificationObj;
      this.residentialService.updateNotificationObject(notificationObj);
    }
  }

  updateFormattedAddressResponse() {
    const Obj = {
      res_question_id: this.data,
      fieldName: 'address',
      fieldValue: {
        address: this.address,
        formatedAddress: this.formatedAddress,
        apartment: this.apartment,
        geoMapAddress: this.geoMapAddress,
        utility: this.selectedUtility,
      },
    };
    this.residentialService.updateResponses(Obj);
  }

  // To set the validation flag on editting the i/p
  setFlag() {
    this.isAddressSelected = false;
    this.callUtilityAPI = false;
    if (!this.isAddressSelected && this.deviceWidth < 768) {
      this.residentialService.unSelectService({ currentId: this.data });
    }
  }

  //help pop up
  send(event, myForm, formValid, modalId) {
    if (formValid) {
      this.modalRef.hide();
      this.contactObj.fullName = this.userObj.fullName;
      this.contactObj.emailId = this.userObj.emailId;
      this.contactObj.question = this.userObj.contactQues;

      const saveContactParam = new HttpParams().append(
        'contactObj',
        JSON.stringify(this.contactObj)
      );

      myForm.resetForm();
      const elementObj = document.getElementById(modalId);
      this.display = 'block';

      this.http
        .post(this.url + '/saveContact', saveContactParam)
        .subscribe((res: any) => {
          this.display = 'none';
          if (!this.cd['destroyed']) {
            this.cd.detectChanges();
          }
          const saveContactResponse = res;
          this.modalRef.hide();
          this.openModal(this.thank);
        });
    }
  }

  closeContactModal(form) {
    this.modalRef.hide();
    form.resetForm();
  }

  closeResetModal() {
    this.router.navigate(['/']);
    this.modalRef.hide();
    this.isAddressSelected = false;
  }

  onCloseHandled() {
    this.modalRef.hide();
    $('#serviceunavialbe').css('display', 'none');
    this.isAddressSelected = false;
    $('.modal-backdrop.show').css('opacity', '0');
    this.formatedAddress = '';
  }

  displayProviderImages(utilityName) {
    return `assets/images/${
      this.loadProvidersImageName[utilityName.replace(/-/g, '')]
    }_logo.svg`;
  }

  getFormattedAddressByState(address) {
    let temp_address = {};
    try{
      var address_ = address;
      if (address_ != "" && address_ != "undefined") {
       let address = address_.split(',');
       let [state, zipcode] = address[2] ? address[2].trim().split(' ') : '';
       if (address[0].toUpperCase().indexOf('APT') > 1) {
         temp_address['street_address'] = address[0].substring(
           0,
           address[0].toUpperCase().indexOf('APT') - 1
         );
         temp_address['apartment'] = address[0].substring(address[0].toUpperCase().indexOf('APT') + 4);
       } else {
         temp_address['street_address'] = address[0];
         temp_address['apartment'] = this.apartment;
       }
       temp_address['city'] = address[1] ? address[1].trim() : '';
       temp_address['state'] = state ? state : '';
       temp_address['zipcode'] = zipcode ? zipcode : '';
     }
     return temp_address;
    }catch{
       return '';
    }
    
  }
}
